import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { TegelModule } from '@scania/tegel-angular-17';
import { DialogService } from 'ng2-bootstrap-modal';
import { IDate, IDatePickerConfig } from 'ng2-date-picker';
import { UtilsService } from 'ng2-date-picker/lib/common/services/utils/utils.service';
import { ToastrService } from 'ngx-toastr';
import { ConfigurationService } from 'src/app/shared/architecture/services/configuration.service';
import { UtilService } from 'src/app/shared/architecture/services/util.service';
import { ConfirmComponent } from 'src/app/shared/modal/confirm/confirm.component';
import { FrontOfficeRequestFilter } from 'src/app/shared/models/frontofficerequestFilter.model';
import { BankService } from 'src/app/shared/services/core/bank.component.service';
import { FrontOfficeRequestService } from 'src/app/shared/services/core/front-office-request.service';
import { FrontOfficesService } from 'src/app/shared/services/core/front-offices.service';

@Component({
  selector: 'app-solic-fof-banco',
  imports: [TegelModule, CommonModule],
  templateUrl: './solic-fof-banco.component.html',
  styleUrl: './solic-fof-banco.component.scss'
})
export class SolicFofBancoComponent implements OnInit {
  frontOffices!: any[];
  negs: any[] = [];
  banks: any[] = [];
  credits: any[] = [];
  request: any[] = [];
  requestFilter: FrontOfficeRequestFilter;
  page = 1;
  total!: number;
  reverse: boolean = false;
  order = "ID";

  dateConfigPeriodFrom: IDatePickerConfig = { 
    //locale: 'pt',
    format: 'DD/MM/YYYY',
    showMultipleYearsNavigation: true,
    disableKeypress: true
  };

  dateConfigUpTo: IDatePickerConfig = {
    //locale: 'pt',
    format: 'DD/MM/YYYY',
    showMultipleYearsNavigation: true,
    disableKeypress: true
  };

  constructor(
    private dialogService: DialogService,
    private utilService: UtilService, 
    private frontOfficesService: FrontOfficesService,
    private bankService: BankService,
    private frontOfficesRequestService: FrontOfficeRequestService, 
    private toastrService: ToastrService,
    private configurationService: ConfigurationService,
    private util: UtilService
  ) {
    this.requestFilter = new FrontOfficeRequestFilter();
    this.request = [];
    this.frontOfficesService.get().subscribe((result) => {
      this.frontOffices = result;
    });
    this.bankService.getPartnerBanks().subscribe((result) => {
      this.banks = result;
    });
    this.frontOfficesRequestService.getNegs().subscribe((result) => {
      this.negs = result;
    });
    this.credits = this.utilService.getCredits();
  }

  ngOnInit(): void { }

  changeDateFrom(value: any) {
    this.dateConfigUpTo.min = value;
    this.dateConfigUpTo = { ...this.dateConfigUpTo };
  }

  changeDateTo(value: any) {
    this.dateConfigPeriodFrom.max = value;
    this.dateConfigPeriodFrom = { ...this.dateConfigPeriodFrom };
  }

  // exportFile() {
  //   this.dialogService.addDialog(ConfirmComponent, {
  //     title: 'Atenção',
  //     message: 'Ao realizar a opção de Exportar para Arquivo novas linhas serão geradas no Follow-Up. Você deseja incluí-las ?'
  //   }, this.utilService.getModalOptions()).subscribe((resultConfirm) => {
  //     if (this.requestFilter.credit.length == 0) {
  //       this.toastrService.info("Favor selecionar as situações de crédito", "Campo Obrigatóro");
  //       return false;
  //     }

  //     let credits = this.requestFilter.credit.length > 0 ? "'" + this.requestFilter.credit.join("','") + "'" : "";
  //     let negs = this.requestFilter.neg.length > 0 ? "'" + this.requestFilter.neg.join("','") + "'" : "";

  //     let vUrl = localStorage.getItem('ffsDatabase') + this.util.getOwnerEnv() + "/pcd_consultas.FrontOfficeSolic?pBanco=" + this.requestFilter.bank + "&pPrevisaoDe=" + this.requestFilter.startDate + "&pFrontOffice=" + (this.requestFilter.frontOffice || "") + "&pExportToExcel=S" +
  //       "&pFlag=CONSULTAR&pPrevisaoAte=" + this.requestFilter.endDate + "&pSitCredito=" + credits + "&pEstagioNegocio=" + negs + "&pNaoDefinido=" + (this.requestFilter.defined ? "S" : "N");

  //     if (resultConfirm.confirmed) {
  //       vUrl += "&pGerarFollowUp=S"
  //     }

  //     window.open(vUrl, '_blank');
  //   });
  // }



  getAll(page: number) { 
    this.frontOfficesRequestService.get(page, this.order, this.utilService.getOrderType(this.reverse), this.requestFilter).subscribe((result) => {
      this.request = result.content.page;
      this.page = result.content.currentPage;
      this.total = result.content.totalRecords;
    });
  }

  resetFilters(form: NgForm) {
    this.requestFilter = new FrontOfficeRequestFilter();
    form.resetForm(this.requestFilter);
  }

  search() {
    this.getAll(1);
  }

}
